import React, { Component } from 'react';
// Pages
import Map from './pages/Map';
// Components
// import Header from './components/Header';
import Coordinates from './components/Coordinates';
import SideBar from './components/SideBar';
import Overlay from './components/Overlay';
import LocationContent from './components/LocationContent';
import WorkDetail from './components/WorkDetail';
import MobileNav from './components/MobileNav';
import navigation from './navigation';


import {init, logPageView} from './utils/analytics';

class App extends Component {
  constructor(props) {
    super(props);
    this.enableScroll = this.enableScroll.bind(this)

    this.state = { 
      user: null,
      coordinates: null,
      zoom: null,
      scrollEnabled: false,
      jumpTo: null,
      overlay: true,
      overlayOpacity: 1,
      sideBar: false,
      locationContent: true,
      workContent:null,
      workComponent:false,
      workDetail: false,
      details: false,
      isMobile: false,
      navContent:null,
      coordArray: []
     }
  }

  componentDidMount() {
    init();
    logPageView();


    if(window.innerWidth < 768 ){
      this.setState({
        isMobile: true
      })
    }


   
    window.addEventListener('resize', this.handleResize);
    
  }
  


  enableScroll() {

    this.setState({
      scrollEnabled: true
    })

  }

  handleResize = () => {
      
      if(window.innerWidth < 768 ){
        this.setState({
          isMobile: true
        })
      }else{
        this.setState({
          isMobile: false
        })
      }
      this.forceUpdate();
  };

  activateOverlay = () => {
    setTimeout(() => {
      this.setState({
        overlay: true
      })
    }, 1000);
  }

  exitOverlay= () => {

    setTimeout(()=> {
      this.setState((state, props) => ({ overlayOpacity: 0 }), () => {
        setTimeout(()=> {
          this.setState(()=> ({ overlay: false }))
        }, 600);
      })
    }, 500);


  }

  
  mapRendered=()=> {
    this.setState({
      sideBar: true
    })
  }

  handleCoordinates = (coordValue, zoom) => {
    this.setState({
      coordinates: coordValue,
      zoom: zoom
    });
  }

  handleJumpTo = (coords, zoom) => {

    this.setState({jumpTo: {coords, zoom}})
  } 

  activateWorkComponentContainer =()=>{
    this.setState({ 
      workComponent: true
    })
  }

  closeDetail = ()=>{
    this.setState({ workDetail: false})
  }

  removeWorkComponentContainer = ()=>{
    this.setState({ workComponent: false})
  }



  getWorkContent = (content) => {
    this.setState({
      workContent: content,
      workDetail: true,
      showWorkDetails: true
    })
  }


  getNavContent = (content) => {
    this.setState({
      navContent : content,
      workDetail: true,
      details: false,
      showWorkDetails: false
    })
  }  

  coordArray = (content) => {
    // console.log(content)
    var joined = this.state.coordArray.concat([content]);
    this.setState({
      coordArray : joined
    })
    
  }

  
  getLocationContent = (content) => {
    this.setState({
      workContent: content,
      workDetail: true,
      showWorkDetails: false
    })
  }


  render() {
    let OverlayContainer;
    let SideBarContainer;
    let LocationContentContainer;
    let WorkDetailContainer;
    let MobileNavContainer;
    let MapContainer;
    if(this.state.overlay){
      OverlayContainer = <Overlay exit={this.exitOverlay}
                            overlayOpacity = {this.state.overlayOpacity}/>
    }
    if(this.state.sideBar) {
      SideBarContainer =  <SideBar 
                          jumpTo = { this.handleJumpTo }
                          activateOverlay= {this.activateOverlay} 
                          activateWorkComponent= {this.activateWorkComponentContainer}
                          removeWorkComponent= {this.removeWorkComponentContainer}
                          exitOverlay = {this.exitOverlay}
                          getNavContent = {this.getNavContent}
                          closeDetail = {this.closeDetail}
                          isMobile= {this.state.isMobile}/>
    }
    
    if(this.state.workDetail){
       WorkDetailContainer= <WorkDetail 
                              details={this.state.workContent}
                              closeDetail={this.closeDetail}
                              showWorkDetails={this.state.showWorkDetails}
                              handleJumpTo = {this.handleJumpTo}
                              isMobile = {this.state.isMobile}/>
    }

    if(this.state.isMobile) {
      MobileNavContainer = <MobileNav
                            getNavContent= {this.getNavContent}
                            jumpTo = { this.handleJumpTo } 
                            closeDetail = {this.closeDetail} 
                            getLocationContent= {this.getLocationContent}/>

    }
    if(!this.state.isMobile){
      MapContainer = <Map 
                      coordinatesValue={this.handleCoordinates}
                      scrollHandler = { this.state.scrollEnabled } 
                      renderComponents={this.mapRendered}
                      jumpTo={this.state.jumpTo}
                      getWorkContent={this.getWorkContent}
                      navContent = {this.state.navContent}
                      isMobile = {this.state.isMobile}
                      coordArray = { this.coordArray }/>
    }
    // <Coordinates 
    //          coordinates = {this.state.coordinates}
    //          zoom = {this.state.zoom} 
    //          scrollHandler = {this.enableScroll}
    //          coordArray = {this.state.coordArray}/>


    //          <img 
    //           src={require('../assets/img/brad-logo.png')} 
    //           style={{width:"100%"}} 
    //           onLoad={(e)=>{
    //             this.props.exitOverlay();
    //             this.toggleEnterState();
    //             }
    //           }
    //            alt=""/>

    return (
      <div className="App">
        <div className="OneThirdGrid">
          {SideBarContainer}
        </div>
          
          
        
        
        <div className="WorkDetailWrapper">
          { WorkDetailContainer }
        </div>
        

        {LocationContentContainer}
          
        
        {OverlayContainer}
        
        { MapContainer }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js